<template>
  <aside id="side-overlay">
    <!-- Side Header -->
    <div class="bg-image">
      <div class="bg-header-dark fixed-top">
        <div class="content-header">
          <button @click="getResults()" class="btn btn-block btn-light mr-3">
            <i class="fa fa-fw fa-sync-alt mr-1"></i> {{$t('layout.sideOverlay.updateSearch')}}
          </button>
          <!-- Close Side Overlay -->
          <a @click="toggleSideOverlay" class="ml-auto text-white" href="javascript:void(0)">
            <i class="fa fa-times-circle"></i>
          </a>
          <!-- END Close Side Overlay -->
        </div>
      </div>
    </div>
    <!-- END Side Header -->

    <!-- Side Content -->
    <div class="content-side">
      <!-- Side Overlay Tabs -->
      <div class="block block-transparent pull-x pull-t">
        <div class="block-content overflow-hidden">
          <!-- Filter Tab -->
          <div class="pull-x fade fade-up show active" id="so-settings">
            <div class="block mb-0">
              <!-- Time Min / Max -->
              <div class="block-content block-content-sm block-content-full bg-body">
                <span class="text-uppercase font-size-sm font-w700">{{$t('layout.sideOverlay.timeRange')}}</span>
              </div>
              <div class="block-content block-content-full">
                <div class="form-group">
                  <label for="example-select">{{$t('layout.sideOverlay.select')}}</label>
                  <select v-model="time_min_pre" class="form-control" id="example-select" name="example-select">
                    <option value="6">6 {{$t('layout.sideOverlay.hours')}}</option>
                    <option value="12">12 {{$t('layout.sideOverlay.hours')}}</option>
                    <option value="24">24 {{$t('layout.sideOverlay.hours')}}</option>
                    <option value="72">3 {{$t('layout.sideOverlay.days')}}</option>
                    <option value="168">7 {{$t('layout.sideOverlay.days')}}</option>
                    <option value="720">30 {{$t('layout.sideOverlay.days')}}</option>
                    <option value="2160">3 {{$t('layout.sideOverlay.months')}}</option>
                    <option value="4320">6 {{$t('layout.sideOverlay.months')}}</option>
                    <option value="8640">1 {{$t('layout.sideOverlay.year')}}</option>
                  </select>
                </div>
              </div>
              <!-- END Time Min / Max -->
              <!-- Direction -->
              <div class="block-content block-content-sm block-content-full bg-body">
                <span class="text-uppercase font-size-sm font-w700">{{$t('layout.sideOverlay.direction')}}</span>
              </div>
              <div class="block-content block-content-full">
                <div class="row gutters-tiny text-center">
                  <div class="col-6 mb-1">
                    <button @click="updateFilter('direction', 'incoming')" class="btn btn-block py-3 bg-body-dark font-w600 text-dark" :class="{ 'active-filter ': filters.direction === 'incoming' }">{{$t('layout.sideOverlay.incoming')}}</button>
                  </div>
                  <div class="col-6 mb-1">
                    <button @click="updateFilter('direction', 'outgoing')" class="btn btn-block py-3 bg-body-dark font-w600 text-dark" :class="{ 'active-filter ': filters.direction === 'outgoing' }">{{$t('layout.sideOverlay.outgoing')}}</button>
                  </div>
                  <div class="col-12 mb-1">
                    <button @click="updateFilter('direction', 'both')" class="btn btn-block py-3 bg-body-dark font-w600 text-dark" :class="{ 'active-filter ': filters.direction === 'both' }">{{$t('layout.sideOverlay.both')}}</button>
                  </div>
                </div>
              </div>
              <!-- END Direction -->

              <!-- Quantity Min / Max -->
              <div class="block-content block-content-sm block-content-full bg-body">
                <span v-if="filters.accumulated" class="text-uppercase font-size-sm font-w700">{{$t('layout.sideOverlay.transfersMinMax')}}</span>
                <span v-else class="text-uppercase font-size-sm font-w700">{{$t('layout.sideOverlay.quantityMinMax')}}</span>
              </div>
              <div class="block-content block-content-full">
                <div class="row gutters-tiny">
                  <div class="col-6">
                    <div class="form-group">
                      <label>{{$t('layout.sideOverlay.quantityMin')}}</label>
                      <input v-model="quantity_min" class="form-control" :placeholder="$t('layout.sideOverlay.optional')">
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label>Max</label>
                      <input v-model="quantity_max" class="form-control" :placeholder="$t('layout.sideOverlay.optional')">
                    </div>
                  </div>
                </div>
                <div class="row gutters-tiny">
                  <div class="col-6">
                    <div class="form-group">
                      <label>{{$t('layout.sideOverlay.accumulatedMin')}}</label>
                      <input v-model="accumulated_min" class="form-control" :placeholder="$t('layout.sideOverlay.optional')">
                    </div>
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label>Max</label>
                      <input v-model="accumulated_max" class="form-control" :placeholder="$t('layout.sideOverlay.optional')">
                    </div>
                  </div>
                </div>
              </div>
              <!-- END Quantity Min / Max -->

              <!-- Exclude Category -->
              <div class="block-content block-content-sm block-content-full bg-body">
                <span class="text-uppercase font-size-sm font-w700">Exclude Category</span>
              </div>
              <div class="block-content block-content-full">
                <b-form-group>
                  <b-form-checkbox-group switches id="filter-excludes" name="excludedCategories" v-model="excludedCategories">
                    <div class="row">
                      <div class="col-6">
                        <b-form-checkbox value="system" class="mb-3">System</b-form-checkbox>
                        <b-form-checkbox value="blacklist">Blacklist</b-form-checkbox>
                      </div>
                      <div class="col-6">
                        <b-form-checkbox value="exchanges" class="mb-3">Exchanges</b-form-checkbox>
                        <b-form-checkbox value="dapps" >Dapps</b-form-checkbox>
                      </div>
                    </div>
                  </b-form-checkbox-group>
                </b-form-group>
              </div>
              <!-- END Exclude Category -->

              <!-- Exclude Accounts -->
              <div class="block-content block-content-sm block-content-full bg-body">
                <span class="text-uppercase font-size-sm font-w700">Exclude Account</span>
              </div>
              <div class="block-content block-content-full">
                <vue-tags-input
                  v-model="tag"
                  :tags="excludedAccounts"
                  :validation="tagValidation"
                  @tags-changed="newTags => excludedAccounts = newTags"
                  placeholder="Enter Accounts here ..."
                  :add-on-key="[13, ',', ' ']"
                />
              </div>
              <!-- END Exclude Accounts -->
            </div>
          </div>
          <!-- END Filter Tab -->
        </div>
      </div>
      <!-- END Side Overlay Tabs -->
    </div>
    <!-- END Side Content -->
  </aside>
</template>

<script>
import { mapMutations } from 'vuex'
import VueTagsInput from '@johmun/vue-tags-input'

export default {
  name: 'sideOverlay',
  components: {
    VueTagsInput
  },
  data () {
    return {
      tag: '',
      tags: [],
      tagValidation: [{
        classes: 'min-length',
        rule: tag => tag.text.length < 2 && tag.text.length !== 0,
        disableAdd: true
      },
      {
        classes: 'invalid-name',
        rule: /^[a-z1-5.]{0,12}$/,
        disableAdd: true
      }]
    }
  },
  computed: {
    filters () {
      return this.$store.state.filter.filters
    },
    quantity_min: {
      // getter
      get () {
        return this.$store.state.filter.filters.quantity_min
      },
      // setter
      set (value) {
        if (value === '') value = 0
        this.updateFilter('quantity_min', value)
      }
    },
    quantity_max: {
      // getter
      get () {
        return this.$store.state.filter.filters.quantity_max
      },
      // setter
      set (value) {
        if (value === '') value = 0
        this.updateFilter('quantity_max', value)
      }
    },
    accumulated_min: {
      // getter
      get () {
        return this.$store.state.filter.filters.accumulated_min
      },
      // setter
      set (value) {
        if (value === '') value = 0
        this.updateFilter('accumulated_min', value)
      }
    },
    accumulated_max: {
      // getter
      get () {
        return this.$store.state.filter.filters.accumulated_max
      },
      // setter
      set (value) {
        if (value === '') value = 0
        this.updateFilter('accumulated_max', value)
      }
    },
    time_min_pre: {
      // getter
      get () {
        return this.$store.state.filter.filters.time_min_pre
      },
      // setter
      set (value) {
        this.updateFilter('time_min_pre', value)
      }
    },
    excludedCategories: {
      // getter
      get () {
        return this.$store.state.filter.filters.excludedCategories
      },
      // setter
      set (value) {
        this.updateFilter('excludedCategories', value)
      }
    },
    excludedAccounts: {
      // getter
      get () {
        return this.$store.state.filter.filters.excludedAccounts
      },
      // setter
      set (value) {
        this.updateFilter('excludedAccounts', value)
      }
    }
  },
  methods: {
    ...mapMutations([
      'toggleSideOverlay'
    ]),
    getResults () {
      this.toggleSideOverlay()
      if (!['NetworkGraphHome'].includes(this.$route.name)) {
        this.$store.dispatch('loadNetworkGraphData')
        this.$router.push({
          name: 'NetworkGraphNetwork',
          query: this.$store.getters.getRouteParams
        })
      }
    },
    updateFilter (key, value) {
      this.$store.commit('updateFilter', { key: key, value: value })
    }
  }
}
</script>

<style scoped lang="scss">

  .content-side {
    margin-top: 70px;
  }

  .active-filter {
    background-color: #aaaaaa !important;
  }
</style>

<style>
  .vue-tags-input .ti-input {
    border-radius: 0.25rem;
  }
  .vue-tags-input .ti-tag {
    background-color: #0665d0 !important;
  }
  .vue-tags-input .min-length, .vue-tags-input .invalid-name {
    color: red;
  }
</style>
